module.exports = __webpack_public_path__ + "static/media/profile-photo.2158253b.png";